if (!customElements.get('product-recommendations-tabs')) {
  customElements.define(
    'product-recommendations-tabs',
    class ProductRecommendationsTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[data-tab-target]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.tabTarget));
        });
      }

      connectedCallback() {
        // Checked directly (rather than via an event from recently-viewed.js)
        // since that script can execute before or after this one depending
        // on section order on the page - a direct synchronous read avoids
        // depending on load-order timing entirely.
        this.checkRecentlyViewed();
      }

      activate(target) {
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.tabTarget === target;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive);
        });
        this.panels.forEach((panel) => {
          const isActive = panel.dataset.tabPanel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }

      checkRecentlyViewed() {
        const tabButton = this.querySelector('[data-recently-viewed-tab]');
        if (!tabButton || typeof window.getRecentlyViewedItems !== 'function') return;

        const currentId = this.dataset.currentProductId ? Number(this.dataset.currentProductId) : null;
        const items = window.getRecentlyViewedItems(currentId, 1);
        if (items.length === 0) {
          // Recently Viewed is the only tab when "You may also like" is
          // turned off - with nothing to show, hide the whole section
          // instead of leaving a lone heading over an empty panel.
          if (!this.querySelector('[data-also-like-tab]')) {
            const section = this.closest('.shopify-section');
            if (section) section.hidden = true;
          }
          return;
        }

        tabButton.hidden = false;
      }
    }
  );
}
